import React from 'react';
import './Badge.css';

type Tone = 'free' | 'occupied' | 'paying' | 'long' | 'neutral';

interface Props {
  tone?: Tone;
  children: React.ReactNode;
  size?: 'sm' | 'md';
}

export function Badge({ tone = 'neutral', size = 'sm', children }: Props) {
  return <span className={`staff-badge-v2 staff-badge-tone-${tone} staff-badge-size-${size}`}>{children}</span>;
}
